import React, { useState, useEffect } from 'react'
import SecondNav from "../../components/secondNav/secondNav";
import JoinNow from "../../components/how-it-works/joinNow";
import Cookies from 'js-cookie';
import { NextSeo } from 'next-seo';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import Link from "next/link"
import { useRouter } from 'next/router';

function WhatIsSaxenda(props) {
  FreshworksWidget("hide");

  const router = useRouter();
  const [myCart] = useState([]);
  const [price, setPrice] = useState(0);
  const [ready, setReady] = useState(false);


  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])

  const goToCheckout = (cart) => {
    FreshworksWidget("hide");
    FreshworksWidget("hide");

    let payload = {
      testImg: cart.img,
      cartName: cart.name,
      cartPrice: cart.price.toFixed(2),
      cartType: cart.type,
      month: cart.month,
    };
    myCart.push(payload);
    const findUpsells = myCart.find((x) => x.type == "upsells");
    if (findUpsells) {
      let totalPrice = 0;
      for (let i = 0; i < myCart.length; i++) {
        const element = myCart[i];
        totalPrice = totalPrice + parseInt(element.cartPrice);
        let cartAmount = parseInt(element.cartPrice);
        let cartPr = (cartAmount / 100) * 30;
        let cartProfit = cartAmount - cartPr;
        myCart[i].profit = cartProfit;
      }

      Cookies.set("cart", myCart);
      let getPrecent = (totalPrice / 100) * 30;
      Cookies.set("discount", getPrecent);
      let mainPrice = totalPrice - getPrecent;
      Cookies.set("totalPrice", 0);
      setPrice(mainPrice);
    } else {
      Cookies.set("cart", myCart);
      let newPrice;
      if (price != "NaN" && price != undefined) {
        newPrice = parseInt(price) + parseInt(cart.price);
        setPrice(newPrice);
        Cookies.set("totalPrice", 0);
      } else {
        if (findUpsells) {
          setPrice(parseInt(mainPrice));
          Cookies.set("totalPrice", 0);
        } else {
          setPrice(parseInt(cart.price));
          Cookies.set("totalPrice", 0);
        }
      }
    }

    if (props.variant == "ckm") {
      router.push("/checkout")
    } else {
      window.location.href = "checkout";
    }


    Cookies.set("cart", myCart);
  };
  return (

    <>
      <NextSeo
        title="Buy Saxenda Online | Weight Loss Injections | NextMed"
        description="Buy Saxenda weight loss injections at NextMed. Get Saxenda online, a prescription medicine, and start your weight loss journey with GLP-1 receptor agonists."
        canonical="https://www.nextmed.com/what-is-saxenda"
        additionalMetaTags={[
          {
            name: "keywords",
            content: "Saxenda,Saxenda For Weight Loss, Saxenda Weight Loss Drug, Saxenda Weight Loss Injections, Glp 1 For Diabetes, Glp 1 For Weight Loss, Glp 1 Receptor Agonist, Get Saxenda Online, Buy Saxenda Online"
          }
        ]}
      />

      <SecondNav htwActive={"faq"} />
      <div className='container faq-container '>
        <button className='unstyled-buttons h1' onClick={() => { router.back() }}>
          <i className="fa fa-long-arrow-left arrow-left-medication text-primary" aria-hidden="true"></i>
        </button>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "45px", width: "300px" }}>
          <h1 className='faq_title'>Saxenda Weight Loss</h1>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>What is Saxenda?</h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'>Saxenda is an FDA-approved medication developed for weight-loss. The drug was developed by Novo Nordisk, one of the world’s largest pharmaceutical companies and released in 2014. Novo Nordisk specializes in the development of drugs called GLP-1’s, which have been shown to work well in managing insulin levels in type-2 diabetics. Novo Nordisk developed drugs called Wegovy and Ozempic, both based on a molecule called “semaglutide.” They discovered that in overweight or obese diabetic patients, these drugs curbed appetites and led to remarkable weight loss properties. Saxenda is a GLP-1 drug based on “liraglutide,” a very similar active ingredient to that in Wegovy. Due to supply shortages of Wegovy, your doctor may choose to prescribe Saxenda for weight-loss to closely match the weight-loss properties of Wegovy.  </p>
        </ReactPlaceholder>

        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>How does Saxenda Work?</h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'>Saxenda’s active ingredient is called liraglutide. Liraglutide works by simulating the effects of the hormone your body produces when you eat food, called incretin. After you eat a big meal, your body releases incretin which signals the feeling of fullness and tells your brain to stop eating. In addition, it also helps to prevent the effects of insulin resistance which also contributes to a feeling of fullness and reduces cravings for sugary or unhealthy foods. Coupled with diet and exercise, Saxenda has been shown to have remarkable weight loss properties.

          </p>

        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>How do I take Saxenda?</h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'>
            Clinical studies have shown an average of 9% loss in body weight, with the majority of the weight-loss happening earlier in the program (within the first 6 months). When coupled with your NextMed diet and exercise program, your weight-loss could be considerably higher. With any weight-loss program, it will still be important to change your lifestyle and exercise will-power. However, the medication will make this process significantly easier. </p>

        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>How much weight do I lose on Saxenda?</h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'><a href='https://www.saxenda.com/about-saxenda/benefits-of-saxenda.html'>Novo Nordisk</a> reports that 85% of Saxenda users lost weight when combined with diet and exercise. 3 out of 5 people lost 5% of their body weight or more, and 1 out of 3 lost greater than 10% of body weight. </p>

        </ReactPlaceholder>

        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>Saxenda Side Effects:</h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'>
            The majority of individuals who take Saxenda® typically experience minimal side effects. Nevertheless, some side effects are considered normal and not considered to be a serious health risk. The most frequent side effects that occur with Saxenda® are nausea, diarrhea, vomiting, constipation, stomach pain, headache, fatigue, upset stomach, dizziness, bloating, belching or gas, stomach flu, heartburn, and loss of appetite. If any of these side effects become bothersome or persistent, it's essential to consult with a healthcare professional. Your medical team can provide guidance and supportive care for any concerns that arise. In the event of severe side effects, such as anaphylaxis or breathing difficulties, it is crucial to seek immediate medical attention.
          </p>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
          <h5 className='faq-mt'>Saxenda Black-Box Warning: </h5>
        </ReactPlaceholder>
        <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "15px", marginTop: "20px" }}>
          <p className='faq-mt'>
            WARNING: RISK OF THYROID C-CELL TUMORS
            Liraglutide causes dose-dependent and treatment-duration-dependent thyroid C-cell tumors at clinically relevant exposures in both genders of rats and mice. It is unknown whether Saxenda® causes thyroid C-cell tumors, including medullary thyroid carcinoma (MTC), in humans, as the human relevance of liraglutide-induced rodent thyroid C-cell tumors has not been determined.
          </p>
          <p>Saxenda® is contraindicated in patients with a personal or family history of MTC and in patients with Multiple Endocrine Neoplasia syndrome type 2 (MEN 2). Counsel patients regarding the potential risk of MTC with use of Saxenda® and inform them of symptoms of thyroid tumors (eg, a mass in the neck, dysphagia, dyspnea, persistent hoarseness). Routine monitoring of serum calcitonin or using thyroid ultrasound is of uncertain value for early detection of MTC in patients treated with Saxenda®.</p>
          <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "25px", width: "500px", marginTop: "20px" }}>
            <h5 className='faq-mt'>Saxenda Packaging Insert: </h5>
          </ReactPlaceholder>
          <p><a className="text-primary" href="https://www.novo-pi.com/saxenda.pdf"> https://www.novo-pi.com/saxenda.pdf</a></p>
        </ReactPlaceholder>
      </div>
      {/* <JoinNow goToCheckout={goToCheckout} /> */}
    </>
  )
}

export default WhatIsSaxenda